import EventEmitter, { EVENT_TYPES } from '@lib/eventEmitter';

interface DisclaimerButtonProps {
  disclaimer:
    'vehicleTax' | 'electricVehicleTax' | 'mpgAndCo2' | 'electricRange';
}

const DisclaimerButton = ({ disclaimer }: DisclaimerButtonProps) => {
  const openModal = () =>
    EventEmitter.emit(EVENT_TYPES.openModal, 'disclaimerModal', {
      disclaimer: disclaimer,
    });

  return (
    <button
      className="ch-btn ch-btn--link disclaimer-btn"
      onClick={openModal}
      type="button"
    >
      Info
    </button>
  );
};

export default DisclaimerButton;
